import { useSelector } from "react-redux";
import { useLoggedInGetSponsorUserDetails } from "./queries";
import { useUserRole } from "../utils/helperMethods";
import { vqaOnlyStatus } from "../utils/vqaOnlyOrg";

/**
 * Whether the logged-in sponsor's org is VQA only, or null until its profile has loaded. For
 * screens that must not show a VQA only org anything about VQQs, even for a moment.
 * @returns {boolean | null}
 */
export default function useOrgVqaOnlyStatus() {
  const role = useUserRole();
  const storedProfile = useSelector((state) => state?.loggedInUser?.userDetails);
  const { data: fetchedProfile, isLoading } = useLoggedInGetSponsorUserDetails(role);
  const storedStatus = vqaOnlyStatus(storedProfile, true);
  return storedStatus ?? vqaOnlyStatus(fetchedProfile, isLoading);
}
